import React from 'react';
import { BatteryCharging } from 'react-feather';

interface BatteryHealthBarProps {
  degradationPercentage: number | null;
}

export const BatteryHealthBar: React.FC<BatteryHealthBarProps> = ({
  degradationPercentage,
}) => {
  let gradient = 'bg-neutral-100';
  let color = 'text-neutral-800';
  let percentage = 0;
  let upper = 100;
  let lower = 0;

  if (degradationPercentage !== null) {
    percentage = degradationPercentage * 100;
    lower = Math.floor(percentage / 5) * 5;
    upper = Math.min(lower + 5, 100);

    gradient = 'bg-battery-health-good';
    color = 'text-green-medium';

    if (percentage < 90 && percentage >= 80) {
      gradient = 'bg-battery-health-average';
      color = 'text-yellow-medium';
    } else if (percentage < 80) {
      gradient = 'bg-battery-health-bad';
      color = 'text-red-medium';
    }
  }

  return (
    <>
      <div className="force-print-background relative flex h-[40px] w-full overflow-hidden rounded-xsmall bg-neutral-100">
        <div
          className={`absolute left-0 top-0 h-full ${gradient}`}
          style={{ width: `${percentage}%` }}
        />
        <div className="absolute left-0 top-0 flex h-full w-full justify-evenly">
          <div className="flex h-full w-[5px] bg-neutral-0" />
          <div className="flex h-full w-[5px] bg-neutral-0" />
          <div className="flex h-full w-[5px] bg-neutral-0" />
          <div className="flex h-full w-[5px] bg-neutral-0" />
        </div>
      </div>

      <div
        className={`flex justify-between py-s pb-s pt-l m:items-center ${color}`}
      >
        <div className="text-body1Regular text-neutral-900">
          Est. Full charge Capacity
        </div>
        <div className="flex items-center gap-s whitespace-nowrap">
          <div className="flex">
            {degradationPercentage ? `${lower}% - ${upper}%` : 'Missing data'}
          </div>
          <div className="flex">
            <BatteryCharging />
          </div>
        </div>
      </div>
      <div className="border-b border-neutral-200 pb-xs text-body2Light text-neutral-800 m:pb-s">
        <p>
          All batteries lose capacity over time. The vehicle&apos;s charging
          history, age, use, and the weather impact degradation, resulting in
          range loss.
        </p>
      </div>
    </>
  );
};
